import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class WebhookTopicSubscriptionEventQueryCriteriaClass extends BaseCriteriaModel {
    //header, bl_webhook_topic_subscription_event table
    guid?: Optional<string> = Optional.empty();
    topic_hdr_guid?: Optional<string> = Optional.empty();
    subscription_hdr_guid?: Optional<string> = Optional.empty();
    action?: Optional<string> = Optional.empty();
    created_date?: Optional<string> = Optional.empty();
}

export class WebhookTopicSubscriptionEventCriteriaModelQuery {
  query = '';

  constructor(WebhookTopicSubscriptionEventCriteriaModel: WebhookTopicSubscriptionEventQueryCriteriaClass) {

    if (!WebhookTopicSubscriptionEventCriteriaModel) {
      return;
    }

    this.query += WebhookTopicSubscriptionEventCriteriaModel.guid.filter(x => x !== '').map(x => '&guid=' + x).orElse('');
    this.query += WebhookTopicSubscriptionEventCriteriaModel.topic_hdr_guid.filter(x => x !== '').map(x => '&topic_hdr_guid=' + x).orElse('');
    this.query += WebhookTopicSubscriptionEventCriteriaModel.subscription_hdr_guid.filter(x => x !== '').map(x => '&subscription_hdr_guid=' + x).orElse('');
    this.query += WebhookTopicSubscriptionEventCriteriaModel.action.filter(x => x !== '').map(x => '&action=' + x).orElse('');
    this.query += WebhookTopicSubscriptionEventCriteriaModel.created_date.filter(x => x !== '').map(x => '&created_date=' + x).orElse('');

    this.query += '&status=' + WebhookTopicSubscriptionEventCriteriaModel.status;
    this.query += '&orderBy=' + WebhookTopicSubscriptionEventCriteriaModel.orderBy;
    this.query += '&order=' + WebhookTopicSubscriptionEventCriteriaModel.order;
    this.query += '&offset=' + WebhookTopicSubscriptionEventCriteriaModel.offset + '&limit=' + WebhookTopicSubscriptionEventCriteriaModel.limit;
  }
}
